import $ from "jquery"; // Import jQuery
import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import useRequiredFields from "../../../../hooks/useRequiredFields";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";

const CreatePlanning = () => {
  const { checkRequiredFields } = useRequiredFields();
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState({});
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [itemLoading, setItemLoading] = useState(false);
  const [product, setProduct] = useState([]);
  const [rmpm, setRmpm] = useState([]);
  const [workOrders, setWorkOrders] = useState([]);

  useEffect(() => {
    initializeDates();
    fetchInitialData();
    $("body").addClass("collapse-menu");
    $("body").toggleClass("show-left");
  }, []);

  const fetchInitialData = async () => {
    setLoading(true);
    try {
      const resWorkOrders = await Http.get(
        "/production-work-order?expire_check=1&show_all=1"
      );
      setWorkOrders(resWorkOrders.data);
      const resInvoiceNo = await Http.get(
        "/last-code-increment-by-one/plannings/receipt_no/PL"
      );
      setInputs((values) => ({
        ...values,
        receipt_no: resInvoiceNo.data,
      }));
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  const addMoreList = async (id) => {
    setItemLoading(true);
    try {
      const response = await Http.get(`/production-work-order/${id}`);
      const hasDuplicates = list.some((group) => group.id === response.data.id);

      if (hasDuplicates) {
        Swal.fire(
          "Warning!",
          "Same work order is already in the list!",
          "warning"
        );
      } else {
        // Initialize set input_qty values to 0
        if (response.data.set && response.data.set.length > 0) {
          response.data.set = response.data.set.map(set => ({
            ...set,
            input_qty: 0
          }));
        }
        
        // Initialize item input_qty values to available quantity
        if (response.data.items && response.data.items.length > 0) {
          response.data.items = response.data.items.map(item => ({
            ...item,
            input_qty: 0,
            production_work_order_item_id: item.id // Set the production_work_order_item_id to the item's id
          }));
        }
        
        setList((prev) => [...prev, response.data]);
      }
    } catch (error) {
      console.error("Error fetching work order:", error);
      Swal.fire("Error!", "Failed to add work order.", "error");
    } finally {
      setItemLoading(false);
    }
  };

  const removeGroup = (groupIndex) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will remove the entire work order.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Remove the entire group at the specified index
        const updatedList = list.filter((_, i) => i !== groupIndex);
        setList(updatedList);
        Swal.fire("Deleted!", "The group has been removed.", "success");
      }
    });
  };
  // const fetchProductsByWorkOrderId = async (workOrderId) => {
  //   setItemLoading(true);
  //   try {
  //     const res = await Http.get(`/production-work-order/${workOrderId}`);
  //     setList(res.data.items);
  //   } catch (error) {
  //     console.error("Error fetching work order List:", error);
  //     Swal.fire(
  //       "Error!",
  //       "Failed to fetch List for the selected work order.",
  //       "error"
  //     );
  //   } finally {
  //     setItemLoading(false);
  //   }
  // };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setInputs((values) => ({ ...values, [name]: value }));

    // Check if production_work_order_id has been selected
    // if (name === "production_work_order_id" && value) {
    //   await fetchProductsByWorkOrderId(value);
    // }
  };

  const selectHandleChange = async (selectedOption, actionMeta) => {
    const { name } = actionMeta;
    const { value } = selectedOption;

    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleInputChange = (e, groupIndex, itemIndex, availableQty, isSet = false) => {
    const { name, value } = e.target;
    let input_qty = parseInt(value) || 0;

    if (!isSet) {
      setList((prevList) => {
        const updatedList = [...prevList];
        const item = updatedList[groupIndex].items[itemIndex];
        // item[name] = Math.max(0, Math.min(input_qty, availableQty));
        item.input_qty = input_qty; // Allow user to set input_qty freely
        return updatedList;
      });
    } else {
      // For sets, we don't have a previous production quantity to check against
      // So we just update the input value
      setList((prevList) => {
        const updatedList = [...prevList];
        if (!updatedList[groupIndex].set[itemIndex].input_qty) {
          updatedList[groupIndex].set[itemIndex].input_qty = input_qty;
        } else {
          updatedList[groupIndex].set[itemIndex].input_qty = input_qty;
        }
        return updatedList;
      });
    }

    // if (availableQty >= input_qty || isSet) {
      const fieldName = isSet 
        ? `set_input_qty_${groupIndex}_${itemIndex}` 
        : `input_qty_${groupIndex}_${itemIndex}`;
      
      setInputs((prevInputs) => ({
        ...prevInputs,
        [fieldName]: input_qty,
      }));
    // } else {
    //   Swal.fire(
    //     "Warning!",
    //     "You can't add more than available quantity! Available Quantity Is = " +
    //     availableQty,
    //     "warning"
    //   );
    //   setInputs((prevInputs) => ({
    //     ...prevInputs,
    //     [`input_qty_${groupIndex}_${itemIndex}`]: availableQty,
    //   }));
      
    //   // Also update the item's input_qty to match the max available quantity
    //   setList((prevList) => {
    //     const updatedList = [...prevList];
    //     const item = updatedList[groupIndex].items[itemIndex];
    //     item.input_qty = availableQty;
    //     return updatedList;
    //   });
    // }
  };
  console.log(inputs)
  const initializeDates = () => {
    const today = new Date();
    const nextMonthFirstDay = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      2
    ); // First day of next month
    const nextMonthLastDay = new Date(
      today.getFullYear(),
      today.getMonth() + 2,
      1
    ); // Last day of next month

    setInputs((values) => ({
      ...values,
      start_date: nextMonthFirstDay.toISOString().split("T")[0], // Set to 01/11/2024
      end_date: nextMonthLastDay.toISOString().split("T")[0], // Set to 30/11/2024
    }));
  };

  const formSubmit = () => {
    checkRequiredFields();

    const formattedItems = list.map(group => {
      const updatedGroup = { ...group };
      
      // Process regular items
      if (updatedGroup.items && updatedGroup.items.length > 0) {
        updatedGroup.items = updatedGroup.items.map((item, index) => {
          return {
            ...item,
            set_id: null, // Ensure regular items have set_id as null
            
          };
        });
      }
      
      // Format set items to match the structure of regular items
      if (updatedGroup.set && updatedGroup.set.length > 0) {
        const setItems = updatedGroup.set.map((set, index) => {
          return {
            id: null, // This will be treated as production_work_order_item_id
            production_work_order_id: updatedGroup.id,
            product_id: null,
            set_id: set.id, // Set the set_id for set items
            input_qty: set.input_qty || 0,
            set_code: set.code,
            set_name: set.name
          };
        });
        
        // Add set items to the items array
        updatedGroup.items = [...updatedGroup.items, ...setItems];
      }
      
      return updatedGroup;
    });

    inputs.items = formattedItems;
    
    console.log("====================================");
    console.log(inputs.items, 'length');
    console.log("====================================");
    if (inputs.items.length == 0) {
      Swal.fire(
        "Warning!",
        "Please select a list!",
        "warning"
      );
      return false;
    }
    Http.post("/planning", inputs)
      .then((res) => {
        navigate("/planning", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch(function (e) {
        if(e.response.data.message){
            Swal.fire(
            "Warning!",
            e.response.data.message,
            "warning"
          );
        }
        setError(e.response.data.errors);
      });
  };

  const displayError = (fieldName) => {
    if (error && error[fieldName]) {
      return <div className="text-danger small">{error[fieldName]}</div>;
    }
    return null;
  };
  const cols = [
    {
      field: (WO) => {
        return WO.receipt_no + " / " + WO.work_order_date;
      },
      header: "Work Order",
    },
    { field: "company.name", header: "Company" },
  ];
  const actionTemplate = (item, deleteData) => {
    return (
      <td className="text-right">
        <button
          className="btn btn-success btn-sm"
          onClick={() => addMoreList(item.id)}
        >
          <i className="fa fa-plus"></i>
        </button>
      </td>
    );
  };

  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Create Work Plan</h5>
        </div>
        <div className="am-pagebody row d-flex justify-content-evenly">
          <div className="card pd-20 pd-sm-40 col-8">
            <h6 className="card-body-title mg-sm-b-30 text-center">
              Create Work Plan
            </h6>
            <hr></hr>
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label>
                      Work Planning No <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="receipt_no"
                      value={inputs.receipt_no || ""}
                      onChange={handleChange}
                      placeholder="Input Invoice No"
                      data-required
                    />

                    {/* {displayError("receipt_no")} */}
                  </div>

                  <div className="col-lg">
                    <label>
                      Start Date <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="start_date"
                      value={inputs.start_date || ""}
                      onChange={handleChange}
                      placeholder="Input Start Date"
                      data-required
                    />

                    {displayError("date")}
                  </div>
                  <div className="col-lg">
                    <label>
                      End Date <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="end_date"
                      value={inputs.end_date || ""}
                      onChange={handleChange}
                      placeholder="Input End Date"
                      data-required
                    />

                    {displayError("date")}
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg">
                    <label>Remarks</label>
                    <textarea
                      type="text"
                      className="form-control"
                      name="remarks"
                      value={inputs.remarks || ""}
                      onChange={handleChange}
                      placeholder="Remarks"
                    />

                    {/* {displayError("remarks")} */}
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="card-solid">
                    <div className="card-header with-border text-center">
                      <h5 className="card-title mb-0">
                        Work Orders Items in the Order{" "}
                        <i className="fa fa-star required"></i>
                      </h5>
                    </div>
                    <div
                      className="card-body p-0"
                      style={{ maxHeight: "500px", overflow: "auto" }}
                    >
                      <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0">
                        <thead
                          style={{
                            position: "sticky",
                            top: 0,
                            backgroundColor: "white",
                            zIndex: 1,
                          }}
                        >
                          <tr>
                            <th>Product Code</th>
                            <th colSpan={2}> Product</th>
                            <th>Department</th>
                            <th>Shape</th>
                            <th>Decoration Code</th>
                            <th>Decoration Name</th>
                            <th>Glaze Color</th>
                            <th>Order Qty</th>
                            {/* <th>Previous Production Qty</th> */}
                            <th>Qty</th>
                          </tr>
                        </thead>
                        <tbody>
                          {list.length < 1 ? (
                            <tr>
                              <td colSpan={12}>
                                <p
                                  style={{ color: "red" }}
                                  className="text-center mt-3"
                                >
                                  Please Add Few Work Orders for Work Plan
                                </p>
                              </td>
                            </tr>
                          ) : (
                            ""
                          )}

                          {list.map((group, groupIndex) => (
                            <React.Fragment key={`group-${groupIndex}`}>
                              <tr>
                                <td
                                  colSpan={11}
                                  className="text-start font-weight-bold"
                                >
                                  {group.company.name} #{group.receipt_no} (
                                  {group.work_order_date} to{" "}
                                  {group.delivery_date})
                                  <button
                                    className="btn btn-danger btn-sm float-right"
                                    onClick={() => removeGroup(groupIndex)}
                                  >
                                    <i className="fa fa-trash"></i> Remove Work
                                    Order
                                  </button>
                                </td>
                              </tr>

                              {/* Rows for Each Item in the Group */}
                              {group.items.map((item, itemIndex) => (
                                <tr key={`item-${groupIndex}-${itemIndex}`}>
                                  <td>{item.product?.code || ""}</td>
                                  <td colSpan={2}>{item.product?.name || ""}</td>
                                  <td>{item.product?.department_art?.name || "N/A"}</td>
                                  <td>{item.shape?.name || ""}</td>
                                  <td>{item?.decoration?.code || "N/A"}</td>
                                  <td>{item?.decoration_name || "N/A"}</td>
                                  <td>{item?.color?.colour_name || "N/A"}</td>
                                  <td>{item?.qty || 0}</td>
                                  {/* <td>{item.previous_production_qty || 0}</td> */}
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="input_qty"
                                      // value={item.input_qty || 0}
                                      onInput={(e) => {
                                        e.target.value = e.target.value.replace(/\D/g, '');
                                      }}
                                      onChange={(e) =>
                                        handleInputChange(
                                          e,
                                          groupIndex,
                                          itemIndex,
                                          item.qty - (item.previous_production_qty || 0)
                                        )
                                      }
                                      placeholder="Qty"
                                      // data-required
                                    />
                                  </td>
                                </tr>
                              ))}

                              {/* Rows for Each Set in the Group */}
                              {group.set && group.set.length > 0 && (
                                <tr>
                                  <td colSpan={12} className="text-start bg-light">
                                    <strong>Sets</strong>
                                  </td>
                                </tr>
                              )}
                              
                              {group.set && group.set.map((set, setIndex) => (
                                <tr key={`set-${groupIndex}-${setIndex}`} className="bg-light">
                                  <td>{set.code || ""}</td>
                                  <td colSpan={8}>{set.name || ""}</td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="input_qty"
                                      value={set.input_qty || 0}
                                      onInput={(e) => {
                                        e.target.value = e.target.value.replace(/\D/g, '');
                                      }}
                                      onChange={(e) =>
                                        handleInputChange(
                                          e,
                                          groupIndex,
                                          setIndex,
                                          1000, // Using a high number as there's no qty limit for sets
                                          true // isSet flag
                                        )
                                      }
                                      placeholder="Qty"
                                      data-required
                                    />
                                  </td>
                                </tr>
                              ))}
                            </React.Fragment>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-send mg-r-10"></i> Create
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          <div
            className="card pd-20 pd-sm-40 col-3"
            style={{ backgroundColor: "#ffffffc7" }}
          >
            <h6 className="card-body-title mg-sm-b-30 text-center">
              Available Work Orders
            </h6>
            <hr></hr>
            <ReactDataTable
              cols={cols}
              receiveData={workOrders}
              isLoading={loading}
              actionTemplate={actionTemplate}
            // deleteData={deleteData}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatePlanning;
